import React from 'react'

import { IconProps } from '../types'

function Navigate(props: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 2C8.134 2 5 5.134 5 9c0 4.41 4.116 8.799 6.449 11.178.41.442 1.085.442 1.495 0C14.884 17.799 19 13.41 19 9c0-3.866-3.134-7-7-7zm0 10c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
    </svg>
  )
}

export default Navigate
